(function () {
  function heartSVG() {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M12 20.5S3.5 15 3.5 9a4.8 4.8 0 0 1 8.5-3 4.8 4.8 0 0 1 8.5 3c0 6-8.5 11.5-8.5 11.5Z"/></svg>';
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('twk_wishlist') || '[]');
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem('twk_wishlist', JSON.stringify(list));
    } catch (e) {}
  }

  function init() {
    var wishlist = getWishlist();

    document.querySelectorAll('.card__media').forEach(function (media) {
      if (media.querySelector('.twk-wish')) return;

      var link = media.querySelector('a[href*="/products/"]');
      var id = link ? link.getAttribute('href') : '';
      if (!id) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'twk-wish';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = heartSVG();
      if (wishlist.indexOf(id) !== -1) btn.classList.add('active');

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var list = getWishlist();
        var idx = list.indexOf(id);
        if (idx === -1) {
          list.push(id);
          btn.classList.add('active');
        } else {
          list.splice(idx, 1);
          btn.classList.remove('active');
        }
        saveWishlist(list);
      });

      media.appendChild(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();